import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MainModal, Toggle, FeatureList } from '..';
import { getProductFeatures, GroupTypesB2C, Period, createPrice, Status, currencySymbolList } from '../../helpers/product';
import { Button, Title } from '../styled';
import { formatDate } from '../../helpers/util';
import { modalActions } from '../../store/ducks/modal';
import { appActions } from '../../store/ducks/app';
import { UpgradeModalNowLabel, UpgradeModalPriceLabel } from '../styled/Modal';
import { CenterJustified } from '../styled/Flex';

const mapStateToProps = (state: any) => ({
  upgradeSubscriptionModal: state.modalData.upgradeSubscriptionModal,
  prescription: state.appData.prescription,
  subscription: state.appData.subscription,
  products: state.appData.general.products,
  selectedPeriod: state.appData.general.selectedPeriod,
  currency: state.appData.currency,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  toggleUpgradeSubscriptionModal: (isOpen: boolean) => void;
  switchPeriod: () => void;
  upgradeSubscription: () => void;
}
type Props = StateProps & DispatchProps;
class UpgradeModal extends React.Component<Props> {
  handleClose = () => {
    this.props.toggleUpgradeSubscriptionModal(false);
  }

  render() {
    const { prescription, subscription, products, selectedPeriod } = this.props;
    const isActive = subscription?.status === Status.ACTIVE;
    return (
      <MainModal isOpen={this.props.upgradeSubscriptionModal}
        close={this.handleClose} contentLabel="Upgrade Subscription Modal">
        <Title><FormattedMessage id="upgrade_to_premium" /></Title>
        <br />
        <FeatureList features={getProductFeatures(GroupTypesB2C.PREMIUM)} />
        <UpgradeModalNowLabel><FormattedMessage id="upgrade_now_for" /></UpgradeModalNowLabel>
        <UpgradeModalPriceLabel>{ `${currencySymbolList[this.props.currency]}${prescription.upgradePrice}` }</UpgradeModalPriceLabel>
        <small>
          <FormattedMessage
            id={`upgrade_to_premium_description_${subscription.billingPeriod}${isActive ? '' : '_one_off'}`}
            values={
              {
                $1: `${currencySymbolList[this.props.currency]}${prescription.upgradePrice}`,
                $2: createPrice(products, GroupTypesB2C.PREMIUM, Period.YEARLY, this.props.currency),
                $3: createPrice(products, GroupTypesB2C.PREMIUM, selectedPeriod, this.props.currency, true),
                $4: formatDate(Number(subscription?.nextPaymentTimestamp) || prescription.end),
              }
            }
          />
        </small>
        <br />
        {
          isActive && subscription.billingPeriod === Period.MONTHLY &&
        <Toggle contentLabel="prefer_yearly_billing" handleChange={this.props.switchPeriod} checked={selectedPeriod !== Period.MONTHLY} />
        }
        <CenterJustified>
          <Button onClick={this.props.upgradeSubscription}><FormattedMessage id="upgrade_subscription" /></Button>
        </CenterJustified>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, { ...appActions, ...modalActions })(UpgradeModal);
